import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, CheckCircle2, Clock, AlertCircle, FileEdit, TrendingUp, Star, Zap, FileText, Plus, Users, BarChart3, ChevronRight, Layers } from 'lucide-react';
import { ORGANISATION, personById } from '../data/demoOrganisation';
const RECENT_REPORTS = [{
  personId: 'p2',
  date: 'Today',
  score: '4.4'
}, {
  personId: 'p3',
  date: 'Yesterday',
  score: '4.1'
}, {
  personId: 'p1',
  date: 'Oct 12',
  score: '4.6'
}];
export function Dashboard() {
  return <div className="space-y-8 animate-in fade-in duration-500 pb-8" data-id="element-1081" data-mp="628setisrssg">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4" data-id="element-1082" data-mp="kyq27gbc8zcw">
        <div data-id="element-1083" data-mp="fy2f35q8d2ny">
          <h1 className="text-2xl font-semibold text-slate-900" data-id="element-1084" data-mp="fxalg0g71f0b">Dashboard</h1>
          <p className="text-slate-500 mt-1" data-id="element-1085" data-mp="1wc28ryyhfw2r">
            Board and executive assessment activity at {ORGANISATION.name}.
          </p>
        </div>
        <Link to="/app/assessments/new" className="bg-slate-900 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-slate-800 transition-colors flex items-center shrink-0" data-id="element-1086" data-mp="1rgdby3dukta5">
          <Plus className="h-4 w-4 mr-2" data-id="element-1087" data-mp="2bo440mwzu47k" />
          New Assessment
        </Link>
      </div>

      {/* 1-4: Top Metrics Row */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1088" data-mp="2foelavq8kh1q">
        {/* Active Assessments */}
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between" data-id="element-1089" data-mp="1j08afr2q0sf0">
          <div className="flex justify-between items-start mb-4" data-id="element-1090" data-mp="1nz1q9q5hcvic">
            <div className="text-sm font-medium text-slate-500" data-id="element-1091" data-mp="1rzbsqsu2d3sg">
              Active Assessments
            </div>
            <div className="p-2 bg-emerald-50 text-emerald-600 rounded-lg" data-id="element-1092" data-mp="1wrls0zh2jg7e">
              <Zap className="h-4 w-4" data-id="element-1093" data-mp="108xozpfrl7ui" />
            </div>
          </div>
          <div data-id="element-1094" data-mp="106uxf0yyr6no">
            <div className="text-3xl font-semibold text-slate-900" data-id="element-1095" data-mp="14a12446fgps1">3</div>
            <div className="mt-2 text-xs text-emerald-600 flex items-center font-medium" data-id="element-1096" data-mp="1486egi3rujk9">
              <ArrowUpRight className="h-3 w-3 mr-1" data-id="element-1097" data-mp="27jc2881spoqo" />
              <span data-id="element-1098" data-mp="22mvgfki2jmgr">1 ending this week</span>
            </div>
          </div>
        </div>

        {/* Draft Assessments */}
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between" data-id="element-1099" data-mp="2hagjxfiuvnp7">
          <div className="flex justify-between items-start mb-4" data-id="element-1100" data-mp="2ccoqui6h5vjf">
            <div className="text-sm font-medium text-slate-500" data-id="element-1101" data-mp="1ondmkqpx1j0j">Drafts</div>
            <div className="p-2 bg-slate-100 text-slate-600 rounded-lg" data-id="element-1102" data-mp="1jnrbamtnecud">
              <FileEdit className="h-4 w-4" data-id="element-1103" data-mp="1jpkka8rqh95j" />
            </div>
          </div>
          <div data-id="element-1104" data-mp="1xobwfpn1ckr1">
            <div className="text-3xl font-semibold text-slate-900" data-id="element-1105" data-mp="1xko0kju4bm95">2</div>
            <div className="mt-2 text-xs text-slate-500 flex items-center" data-id="element-1106" data-mp="1tjuelw08khiw">
              <Clock className="h-3 w-3 mr-1" data-id="element-1107" data-mp="3914lutscsx3x" />
              <span data-id="element-1108" data-mp="3940jsi47blsd">Last edited 2h ago</span>
            </div>
          </div>
        </div>

        {/* Completed Assessments */}
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between" data-id="element-1109" data-mp="3cjk47ks4f0vv">
          <div className="flex justify-between items-start mb-4" data-id="element-1110" data-mp="3hk7u234m5boi">
            <div className="text-sm font-medium text-slate-500" data-id="element-1111" data-mp="32lxes4d73qxn">Completed</div>
            <div className="p-2 bg-blue-50 text-blue-600 rounded-lg" data-id="element-1112" data-mp="32o08ozhgy47n">
              <CheckCircle2 className="h-4 w-4" data-id="element-1113" data-mp="37limp4acf9mi" />
            </div>
          </div>
          <div data-id="element-1114" data-mp="3vbmfeglztoyq">
            <div className="text-3xl font-semibold text-slate-900" data-id="element-1115" data-mp="3vb37zttyyiyy">15</div>
            <div className="mt-2 text-xs text-slate-500 flex items-center" data-id="element-1116" data-mp="44jprtlszqqm">
              <span className="text-slate-400" data-id="element-1117" data-mp="3ll1g0qyhwger">This quarter</span>
            </div>
          </div>
        </div>

        {/* Awaiting Responses */}
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between" data-id="element-1118" data-mp="3qia4186brenx">
          <div className="flex justify-between items-start mb-4" data-id="element-1119" data-mp="i1ygd1nsm4k6">
            <div className="text-sm font-medium text-slate-500" data-id="element-1120" data-mp="mvt6amtzrfrp">
              Awaiting Responses
            </div>
            <div className="p-2 bg-amber-50 text-amber-600 rounded-lg" data-id="element-1121" data-mp="2vdf4cbao7a5k">
              <Clock className="h-4 w-4" data-id="element-1122" data-mp="2qchm5ypnug42" />
            </div>
          </div>
          <div data-id="element-1123" data-mp="2ldehwghi8dx5">
            <div className="text-3xl font-semibold text-slate-900" data-id="element-1124" data-mp="2lcv1533lbvkp">12</div>
            <div className="mt-2 text-xs text-amber-600 flex items-center font-medium" data-id="element-1125" data-mp="2gel7iwxil317">
              <AlertCircle className="h-3 w-3 mr-1" data-id="element-1126" data-mp="2ggxs7hunprhy" />
              <span data-id="element-1127" data-mp="3e10n1t6drqm4">4 overdue</span>
            </div>
          </div>
        </div>
      </div>

      {/* Middle Row: Score & Quick Actions */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1128" data-mp="395lcba3o6atx">
        {/* 5: Overall Leadership Score */}
        <div className="bg-slate-900 rounded-xl border border-slate-800 shadow-sm p-6 text-white relative overflow-hidden" data-id="element-1129" data-mp="2zdfhztpy3hbk">
          <div className="absolute top-0 right-0 p-6 opacity-10 pointer-events-none" data-id="element-1130" data-mp="np5ea49x47m">
            <Star className="h-32 w-32" data-id="element-1131" data-mp="3s2cypseid627" />
          </div>
          <h2 className="text-lg font-medium text-slate-200 mb-6" data-id="element-1132" data-mp="3s0s7ocrek593">
            Overall Competency Score
          </h2>
          <div className="flex items-end gap-4 mb-6" data-id="element-1133" data-mp="47pmz41avf3r">
            <div className="text-6xl font-bold tracking-tight" data-id="element-1134" data-mp="87pyogx0lc74">4.2</div>
            <div className="text-slate-400 mb-2 font-medium" data-id="element-1135" data-mp="d5i1i5z76iq3">/ 5.0 Avg</div>
          </div>

          <div className="space-y-3" data-id="element-1136" data-mp="i4ul8hurv9og">
            <div className="flex justify-between text-sm" data-id="element-1137" data-mp="i5xh746yc2b8">
              <span className="text-slate-300" data-id="element-1138" data-mp="n4h4b7xa7k56">Board & Executive Benchmark</span>
              <span className="font-medium text-emerald-400 flex items-center" data-id="element-1139" data-mp="r5subek2i7dw">
                <TrendingUp className="h-4 w-4 mr-1" data-id="element-1140" data-mp="r3puy3x0z1wi" />
                Top 15%
              </span>
            </div>
            <div className="w-full bg-slate-800 rounded-full h-2" data-id="element-1141" data-mp="10vm5wfk7mmi5">
              <div className="bg-emerald-400 h-2 rounded-full" style={{
              width: '84%'
            }} data-id="element-1142" data-mp="10v3x6jgd2ftc"></div>
            </div>
          </div>
        </div>

        {/* 7: Quick Actions */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-1143" data-mp="l54n2dj8mnp6">
          <h2 className="text-lg font-medium text-slate-900 mb-4" data-id="element-1144" data-mp="g6tbnydao54u">
            Quick Actions
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-1145" data-mp="uvz8xgsknla3">
            <Link to="/app/assessments" className="flex items-center p-4 border border-slate-200 rounded-lg hover:border-slate-300 hover:bg-slate-50 transition-all group" data-id="element-1146" data-mp="uxk0qyni4q49">
              <div className="bg-indigo-50 p-2 rounded-md text-indigo-600 mr-3 group-hover:bg-indigo-100 transition-colors" data-id="element-1147" data-mp="yx2pk5ig1lcd">
                <Zap className="h-5 w-5" data-id="element-1148" data-mp="1dulasxvwxgf2" />
              </div>
              <div className="text-sm font-medium text-slate-900" data-id="element-1149" data-mp="1drz573sl1azh">
                Launch Cycle
              </div>
            </Link>

            <Link to="/app/reports" className="flex items-center p-4 border border-slate-200 rounded-lg hover:border-slate-300 hover:bg-slate-50 transition-all group" data-id="element-1150" data-mp="3fl6k4c4a9qku">
              <div className="bg-blue-50 p-2 rounded-md text-blue-600 mr-3 group-hover:bg-blue-100 transition-colors" data-id="element-1151" data-mp="1q5m109xrw6h2">
                <BarChart3 className="h-5 w-5" data-id="element-1152" data-mp="1v34ca6z9ixs8" />
              </div>
              <div className="text-sm font-medium text-slate-900" data-id="element-1153" data-mp="1gfjaqhi1d6mf">
                View Insights
              </div>
            </Link>

            <Link to="/app/team" className="flex items-center p-4 border border-slate-200 rounded-lg hover:border-slate-300 hover:bg-slate-50 transition-all group" data-id="element-1154" data-mp="1lc9q12m0ny6s">
              <div className="bg-emerald-50 p-2 rounded-md text-emerald-600 mr-3 group-hover:bg-emerald-100 transition-colors" data-id="element-1155" data-mp="1bgzp6i7ctwul">
                <Users className="h-5 w-5" data-id="element-1156" data-mp="12eysbmg19ctg" />
              </div>
              <div className="text-sm font-medium text-slate-900" data-id="element-1157" data-mp="12f8ipb4zplzo">
                Board & Executives
              </div>
            </Link>

            <Link to="/app/competencies" className="flex items-center p-4 border border-slate-200 rounded-lg hover:border-slate-300 hover:bg-slate-50 transition-all group" data-id="element-1158" data-mp="2wsrby8rzmif6">
              <div className="bg-slate-100 p-2 rounded-md text-slate-600 mr-3 group-hover:bg-slate-200 transition-colors" data-id="element-1159" data-mp="1fk1i4c5bdqwo">
                <Layers className="h-5 w-5" data-id="element-1160" data-mp="1asjpqchcwynb" />
              </div>
              <div className="text-sm font-medium text-slate-900" data-id="element-1161" data-mp="15v03apai9fka">
                Competency Domains
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Row: Action Items & Recent Reports */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1162" data-mp="vvsqc37onmxp">
        {/* Action Items (Contextual to user) */}
        <div className="space-y-4" data-id="element-1163" data-mp="rv8rmv7gob9g">
          <h2 className="text-lg font-medium text-slate-900" data-id="element-1164" data-mp="mvvwln6frxvs">
            Your Action Items
          </h2>
          <div className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm" data-id="element-1165" data-mp="2m8q5fqi2dtra">
            <div className="divide-y divide-slate-100" data-id="element-1166" data-mp="2ha6l1uj4cq11">
              <div className="p-4 flex items-start hover:bg-slate-50 transition-colors" data-id="element-1167" data-mp="2haomd5kn1uft">
                <div className="mt-0.5 bg-amber-100 text-amber-600 p-1.5 rounded-md mr-4 shrink-0" data-id="element-1168" data-mp="2oswkouc4p6n5">
                  <Clock className="h-4 w-4" data-id="element-1169" data-mp="2tqy4jhhdp9zo" />
                </div>
                <div className="flex-1 min-w-0 pr-4" data-id="element-1170" data-mp="2yizcwsbfegkf">
                  <h4 className="text-sm font-medium text-slate-900 truncate" data-id="element-1171" data-mp="2ylljopqhss1l">
                    Complete Self-Assessment
                  </h4>
                  <p className="text-xs text-slate-500 mt-1 truncate" data-id="element-1172" data-mp="25vlndfa24nac">
                    2026 Board Effectiveness Review • Due Tomorrow
                  </p>
                </div>
                <button className="text-sm font-medium text-slate-900 border border-slate-200 px-3 py-1.5 rounded-md hover:bg-slate-100 shrink-0" data-id="element-1173" data-mp="2fs87u2yh1cbu">
                  Start
                </button>
              </div>

              <div className="p-4 flex items-start hover:bg-slate-50 transition-colors" data-id="element-1174" data-mp="3r8ohffncgyqs">
                <div className="mt-0.5 bg-blue-100 text-blue-600 p-1.5 rounded-md mr-4 shrink-0" data-id="element-1175" data-mp="3v8qibml99o50">
                  <AlertCircle className="h-4 w-4" data-id="element-1176" data-mp="1l5l0r3a38k9j" />
                </div>
                <div className="flex-1 min-w-0 pr-4" data-id="element-1177" data-mp="1q3w8n8gtokp4">
                  <h4 className="text-sm font-medium text-slate-900 truncate" data-id="element-1178" data-mp="1q2bf9m68v7su">
                    Approve Rater Nominations
                  </h4>
                  <p className="text-xs text-slate-500 mt-1 truncate" data-id="element-1179" data-mp="1ztfu8lvx6sno">
                    {personById('p2').name}, Chief Executive Officer • 5
                    pending approvals
                  </p>
                </div>
                <button className="text-sm font-medium text-slate-900 border border-slate-200 px-3 py-1.5 rounded-md hover:bg-slate-100 shrink-0" data-id="element-1180" data-mp="1748mqxehmsqa">
                  Review
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* 6: Recent Reports */}
        <div className="space-y-4" data-id="element-1181" data-mp="2nk34hdtb5ude">
          <div className="flex justify-between items-center" data-id="element-1182" data-mp="2nj0dz6zwdty0">
            <h2 className="text-lg font-medium text-slate-900" data-id="element-1183" data-mp="2shlel7j2afmz">
              Recent Reports
            </h2>
            <Link to="/app/reports" className="text-sm font-medium text-slate-600 hover:text-slate-900 flex items-center" data-id="element-1184" data-mp="gtzsof5is6dr">
              View all <ChevronRight className="h-4 w-4 ml-0.5" data-id="element-1185" data-mp="74oliy271bsi" />
            </Link>
          </div>
          <div className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm" data-id="element-1186" data-mp="26ep6k4qg55b">
            <div className="divide-y divide-slate-100" data-id="element-1187" data-mp="3tc6ejhaordr2">
              {RECENT_REPORTS.map(report => {
              const p = personById(report.personId);
              return <Link key={report.personId} to="/app/reports" className="p-4 flex items-center justify-between hover:bg-slate-50 transition-colors group" data-id="element-1188" data-mp="3pd78tuh4rcyk">
                  <div className="flex items-center min-w-0" data-id="element-1189" data-mp="1ikwr78cx938e">
                    <div className="w-10 h-10 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-sm font-medium text-slate-600 mr-3 shrink-0" data-id="element-1190" data-mp="1ii0ufnct8klj">
                      {p.initials}
                    </div>
                    <div className="min-w-0" data-id="element-1191" data-mp="3csh2ggt9gby7">
                      <div className="text-sm font-medium text-slate-900 truncate" data-id="element-1192" data-mp="3cuboxzk6kc4e">
                        {p.name}
                      </div>
                      <div className="text-xs text-slate-500 truncate" data-id="element-1193" data-mp="331w7r4gpjrkk">
                        {p.title} • {report.date}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center ml-4 shrink-0" data-id="element-1194" data-mp="3vrmn1gu2szi9">
                    <div className="text-right mr-3" data-id="element-1195" data-mp="3voqoprebg8ta">
                      <div className="text-sm font-semibold text-slate-900" data-id="element-1196" data-mp="3gt0yfh23l9ir">
                        {report.score}
                      </div>
                      <div className="text-[10px] text-slate-500 uppercase tracking-wider" data-id="element-1197" data-mp="3luqdr8wcs9cn">
                        Score
                      </div>
                    </div>
                    <div className="text-slate-400 group-hover:text-slate-900 transition-colors" data-id="element-1198" data-mp="2af1oubzjh097">
                      <ChevronRight className="h-5 w-5" data-id="element-1199" data-mp="seahui5r026h" />
                    </div>
                  </div>
                </Link>;
            })}
            </div>
          </div>
        </div>
      </div>
    </div>;
}